var CemeteryStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import Query from "@arcgis/core/rest/support/Query";
import * as query from "@arcgis/core/rest/query";
import { map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiCemeteryConstants } from "../../constants/api-constants/api-cemetery.constants";
import { AlertType } from "../../models/alert";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../../shared/utils/recipient-utils";
import { CreateBurialDetailsCmComponent } from "../../../create-application/modules/cm/create-burial-details-cm/create-burial-details-cm.component";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { ViewFuneralParlourCmComponent } from "../../../view-application/modules/cm/view-funeral-parlour-cm/view-funeral-parlour-cm.component";
import { ViewFamilyMemberCmComponent } from "../../../view-application/modules/cm/view-family-member-cm/view-family-member-cm.component";
import { CreateFamilyMemberDetCmComponent } from "../../../create-application/modules/cm/create-family-member-det-cm/create-family-member-det-cm.component";
import { ViewDeceasedDetailsCmComponent } from "../../../view-application/modules/cm/view-deceased-details-cm/view-deceased-details-cm.component";
import { ViewBurialDetailsCmComponent } from "../../../view-application/modules/cm/view-burial-details-cm/view-burial-details-cm.component";
import { CreateDeceasedDetailsCmComponent } from "../../../create-application/modules/cm/create-deceased-details-cm/create-deceased-details-cm.component";
import { CreateFuneralParlourCmComponent } from "../../../create-application/modules/cm/create-funeral-parlour-cm/create-funeral-parlour-cm.component";
import { DeceasedDtailsCustomValidators } from "../../../create-application/modules/cm/shared/custom-validators";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { ViewApplicationNotesComponent } from "../../../view-application/view-application-notes/view-application-notes.component";
import { CreateApplicationNotesComponent } from "../../../create-application/create-application-notes/create-application-notes.component";
import { CreateApplicationMenuHeadings } from "./bl-strategy.service";
import { GraveSearchOption } from "../../../search-applications/shared/grave-search-option.enum";
import { CemeterySearchOption } from "../../../search-applications/shared/cemetery-search-option.enum";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["CreatedDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
    ApplicationHeadingEnum["BurialDate"] = "Burial Date";
    ApplicationHeadingEnum["DateOfBirth"] = "Date Of Birth";
    ApplicationHeadingEnum["BurialOrderNumber"] = "Burial Order Number";
    ApplicationHeadingEnum["SerialNo"] = "Serial Number";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([[ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"], [ApplicationHeadingEnum.Applicant, "applicant"], [ApplicationHeadingEnum.CreatedDate, "startDate"], [ApplicationHeadingEnum.ApplicationStatus, "phase"], [ApplicationHeadingEnum.DaysLeft, "daysLeft"], [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"], [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"], [ApplicationHeadingEnum.BurialDate, "burialDate"], [ApplicationHeadingEnum.DateOfBirth, "dateOfBirth"], [ApplicationHeadingEnum.BurialOrderNumber, "burialOrderNumber"], [ApplicationHeadingEnum.SerialNo, "serialNo"],]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
    ApplicationSummaryColumnsEnum["BurialDate"] = "Burial Date";
    ApplicationSummaryColumnsEnum["DateOfBirth"] = "Date Of Birth";
    ApplicationSummaryColumnsEnum["BurialOrderNumber"] = "Burial Order Number";
    ApplicationSummaryColumnsEnum["SerialNo"] = "Serial Number";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
    [ApplicationSummaryColumnsEnum.BurialDate, "burialDate"],
    [ApplicationSummaryColumnsEnum.DateOfBirth, "dateOfBirth"],
    [ApplicationSummaryColumnsEnum.BurialOrderNumber, "burialOrderNumber"],
    [ApplicationSummaryColumnsEnum.SerialNo, "serialNo"]
]);
export const CMExpandListForApplicationSearch = ApplicationSearchConstants.APP_EXPAND_PORTAL_APP_CM;
export var CreateApplicationCemeteryMenuHeadings;
(function (CreateApplicationCemeteryMenuHeadings) {
    CreateApplicationCemeteryMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationCemeteryMenuHeadings["BurialDetails"] = "Burial";
    CreateApplicationCemeteryMenuHeadings["DeceasedDetails"] = "Deceased";
    CreateApplicationCemeteryMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationCemeteryMenuHeadings["FamilyMemberDetails"] = "Family member";
    CreateApplicationCemeteryMenuHeadings["FuneralParlour"] = "Funeral parlour";
    CreateApplicationCemeteryMenuHeadings["Notes"] = "Notes";
    CreateApplicationCemeteryMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationCemeteryMenuHeadings || (CreateApplicationCemeteryMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["BurialDetails"] = "Burial details help";
    HeaderConfigurableTextTypes["DeceasedDetails"] = "Deceased details help";
    HeaderConfigurableTextTypes["FamilyMemberDetails"] = "Family member details help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["FuneralParlour"] = "Funeral parlour help";
    HeaderConfigurableTextTypes["Notes"] = "Notes help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationCemeteryMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationCemeteryMenuHeadings.BurialDetails, HeaderConfigurableTextTypes.BurialDetails)
    .set(CreateApplicationCemeteryMenuHeadings.DeceasedDetails, HeaderConfigurableTextTypes.DeceasedDetails)
    .set(CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails, HeaderConfigurableTextTypes.FamilyMemberDetails)
    .set(CreateApplicationCemeteryMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationCemeteryMenuHeadings.FuneralParlour, HeaderConfigurableTextTypes.FuneralParlour)
    .set(CreateApplicationCemeteryMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(CreateApplicationCemeteryMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationCemeteryMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["BurialDetails"] = "Burial";
    ViewApplicationMenuHeadings["DeceasedDetails"] = "Deceased";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["FamilyMemberDetails"] = "Family member";
    ViewApplicationMenuHeadings["FuneralParlour"] = "Funeral parlour";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewApplicationMenuConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.BurialDetails, HeaderConfigurableTextTypes.BurialDetails)
    .set(ViewApplicationMenuHeadings.DeceasedDetails, HeaderConfigurableTextTypes.DeceasedDetails)
    .set(ViewApplicationMenuHeadings.FamilyMemberDetails, HeaderConfigurableTextTypes.FamilyMemberDetails)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.FuneralParlour, HeaderConfigurableTextTypes.FuneralParlour)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let CemeteryStrategyService = class CemeteryStrategyService extends AflaModuleStrategyService {
    static { CemeteryStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    appController;
    router;
    viewApplicationSteps = [];
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.Cemetery;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiCemeteryConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = CMExpandListForApplicationSearch;
    lookups = new Map();
    createApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewApplicationMenuConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    previousApplication = null;
    savedApplication;
    postApplicationSubscription;
    getApplicationsSubscription;
    cemeteryUrl;
    graveUrl;
    cemeteryList = new BehaviorSubject([]);
    cemeteryListAsObservable = this.cemeteryList.asObservable();
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiCemeteryConstants.URL}/${ApiCemeteryConstants.FUNCTION_GET_MY_AFLA_PORTAL_CEMETERY_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationCemeteryMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    // TODO Correct 2n arg: TPExpandListForApplicationPartial
    static buildExpand(params) {
        return params.set(ODataAction.Expand, CMExpandListForApplicationSearch);
    }
    buildListFilter(list, column) {
        const params = CemeteryStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    // TODO: Fix Application Search
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: CemeteryStrategyService_1.getRecipientName(CemeteryStrategyService_1.getFirstRecipient(application.applicant)),
            startDate: this.saShortDatePipe.transform(application.createdDate), // TODO: we have relabelled all instances of "Phase" to "Application status"
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
            burialDate: "Burial Date",
            dateOfBirth: "Date Of Birth",
            burialOrderNumber: "Burial Order Number",
            serialNo: "Serial Number"
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [ViewApplicationMenuHeadings.BurialDetails, ViewBurialDetailsCmComponent],
            [ViewApplicationMenuHeadings.DeceasedDetails, ViewDeceasedDetailsCmComponent],
            [ViewApplicationMenuHeadings.FamilyMemberDetails, ViewFamilyMemberCmComponent],
            [ViewApplicationMenuHeadings.FuneralParlour, ViewFuneralParlourCmComponent],
            [ViewApplicationMenuHeadings.Notes, ViewApplicationNotesComponent]
        ]);
    }
    // TODO: setup correct component for each step
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [CreateApplicationCemeteryMenuHeadings.BurialDetails, CreateBurialDetailsCmComponent,],
            [CreateApplicationCemeteryMenuHeadings.DeceasedDetails, CreateDeceasedDetailsCmComponent],
            [CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails, CreateFamilyMemberDetCmComponent],
            [CreateApplicationCemeteryMenuHeadings.FuneralParlour, CreateFuneralParlourCmComponent],
            [CreateApplicationCemeteryMenuHeadings.Notes, CreateApplicationNotesComponent]
        ]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiCemeteryConstants.URL}/${ApiCemeteryConstants.FUNCTION_GET_ALL_AFLA_PORTAL_CEMETERY_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = CemeteryStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, CemeteryStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.postApplicationSubscription = this.postApplicationService(application).subscribe({
            next: (savedApplication) => {
                this.appController.showMessage(CemeteryStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
                this.resetForm();
                this.router.navigate([AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")]).then();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
            }
        });
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        // @ts-ignore
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationCemeteryMenuHeadings.BurialDetails.toLocaleLowerCase():
                application = this.buildBurialDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.DeceasedDetails.toLocaleLowerCase():
                application = this.buildDeceasedStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails.toLocaleLowerCase():
                application = this.buildFamilyMemberStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.FuneralParlour.toLocaleLowerCase():
                application = this.buildFuneralParlourStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.Notes.toLocaleLowerCase():
                application = this.setApplicationNotes(step.stepIndex, existingApplication);
                break;
            case CreateApplicationCemeteryMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            const applicationId = application.id > 0 ? application.id : 0;
            this.savedApplication = undefined;
            const applicationRequestDto = {
                cmApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this as the saved application does not return with the updated family members
                    const params = {
                        $select: "family, deceased,notes",
                        $expand: "family($expand=groups), deceased($expand=deceasedNames),notes",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID} and deleted eq false`
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            const family = response.value[0]?.family;
                            const deceased = response.value[0]?.deceased;
                            savedApplication.family = family;
                            savedApplication.deceased = deceased;
                            if (continueAfterSave && !savedApplication.eLodgementComplete) {
                                --savedApplication.eLodgementStep;
                            }
                            this.savedApplication = savedApplication;
                        }, error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        }, complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(CemeteryStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IT IF YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.cmApplication.eLodgementStep;
                                // NB: DO NOT REMOVE THIS LINE UNLESS YOU HAVE A GOOD REASON! OTHERWISE, IT'S GOING TO CAUSE DUPLICATES!!!!
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(CemeteryStrategyService_1.successMessage(savedApplication.referenceNumber, step.stepTitle), AlertType.Success, true);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                }, error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                },
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        return;
    }
    // TODO Correct the routing here
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiCemeteryConstants.URL}/${applicationId}/${ApiCemeteryConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, applicationRequestDto, continueAfterSave) {
        return this.http.post(`${ApiCemeteryConstants.URL}/${applicationId}/${ApiCemeteryConstants.FUNCTION_CREATE_RESUBMITTED_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    // TODO Add steps
    getCurrentFormName(step) {
        if (step === null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationCemeteryMenuHeadings.BurialDetails.toLocaleLowerCase():
                formName = "burialForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.DeceasedDetails.toLocaleLowerCase():
                formName = "deceasedForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails.toLocaleLowerCase():
                formName = "familyMemberForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.Applicant.toLocaleLowerCase():
                this.requestStatusService.removeBusySpinner("CreateCMApplication");
                formName = "applicantForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.FuneralParlour.toLocaleLowerCase():
                this.requestStatusService.removeBusySpinner("CreateCMApplication");
                formName = "funeralParlourForm";
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                formName = "notesForm";
                break;
            case CreateApplicationCemeteryMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    setApplicationNotes(stepIndex, existingApplication) {
        const noteId = this.form.get("notesForm").get("id").value ? this.form.get("notesForm").get("id").value : 0;
        const noteValue = this.form.get("notesForm").get("note").value;
        let note;
        if (noteValue !== null && noteValue !== "") {
            note = [{ id: noteId, note: noteValue }];
        }
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.notes = note;
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                notes: note,
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    // TODO
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationCemeteryMenuHeadings.BurialDetails.toLocaleLowerCase():
                this.form.get("burialForm").get("type").reset();
                this.form.get("burialForm").get("burialDate").reset();
                this.form.get("burialForm").get("description").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.DeceasedDetails.toLocaleLowerCase():
                this.form.get("deceasedForm").get("sex").reset();
                this.form.get("deceasedForm").get("nationality").reset();
                this.form.get("deceasedForm").get("idNumber").reset();
                this.form.get("deceasedForm").get("idType").reset();
                this.form.get("deceasedForm").get("burialOrderNumber").reset();
                this.form.get("deceasedForm").get("serialNo").reset();
                this.form.get("deceasedForm").get("verticalPosition").reset();
                this.form.get("deceasedForm").get("dateOfBirth").reset();
                this.form.get("deceasedForm").get("dateOfDeath").reset();
                this.form.get("deceasedForm").get("placeOfBirth").reset();
                this.form.get("deceasedForm").get("placeOfDeath").reset();
                this.form.get("deceasedForm").get("maidenName").reset();
                this.form.get("deceasedForm").get("undertaker").reset();
                this.form.get("deceasedForm").get("provinceOfDeath").reset();
                this.form.get("deceasedForm").get("deceasedNames").reset();
                this.selectedApplicationService.clearDeceasedNamesTableSubject$.next(true);
                break;
            case CreateApplicationCemeteryMenuHeadings.FamilyMemberDetails.toLocaleLowerCase():
                this.form.get("familyMemberForm").get("family").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.FuneralParlour.toLocaleLowerCase():
                this.form.get("funeralParlourForm").get("parlourRecipient").reset();
                this.form.get("funeralParlourForm").get("parlourSelector").reset();
                this.form.get("funeralParlourForm").get("funeralParlourIsNull").reset();
                break;
            case CreateApplicationCemeteryMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            case CreateApplicationCemeteryMenuHeadings.Notes.toLocaleLowerCase():
                this.form.get("notesForm").get("note").reset();
                break;
            default:
                break;
        }
    }
    resetForm() {
        this.form.reset();
    }
    // TODO correct the URL
    postApplicationService(params) {
        return this.http.post(ApiCemeteryConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, lastEditedUser, notes";
    }
    // TODO: Correct Constants
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_TP_APPLICATIONS_BY_USER;
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationCemeteryMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value[0].toUpperCase()}${value.substring(1).toLowerCase()}`,
                stepType: key === CreateApplicationCemeteryMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiCemeteryConstants.URL}/${jobId}/GetCmApplicationTypes`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        return true;
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    initForm() {
        this.form = new FormGroup({
            burialForm: new FormGroup({
                type: new FormControl(null, [Validators.required]),
                cemeteryId: new FormControl(null),
                burialDate: new FormControl(null),
                description: new FormControl(null, [Validators.required])
            }),
            deceasedForm: new FormGroup({
                sex: new FormControl(null, [Validators.required]),
                nationality: new FormControl(null, [Validators.required]),
                idNumber: new FormControl(null, [Validators.required]),
                idType: new FormControl(null, [Validators.required]),
                burialOrderNumber: new FormControl(null, [Validators.required]),
                serialNo: new FormControl(null),
                verticalPosition: new FormControl(null, [Validators.required]),
                dateOfBirth: new FormControl(null, [Validators.required, DeceasedDtailsCustomValidators.CompareDateToToday]),
                dateOfDeath: new FormControl(null),
                placeOfBirth: new FormControl(null, [Validators.required]),
                placeOfDeath: new FormControl(null),
                maidenName: new FormControl(null),
                undertaker: new FormControl(null),
                provinceOfDeath: new FormControl(null),
                deceasedNames: new FormControl(null, [Validators.required]),
            }, DeceasedDtailsCustomValidators.CompareDateToDateOfDeath), familyMemberForm: new FormGroup({
                family: new FormControl(null),
            }),
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            funeralParlourForm: new FormGroup({
                parlourRecipient: new FormControl(null, [Validators.required]),
                parlourSelector: new FormControl(null, [Validators.required]),
                funeralParlourIsNull: new FormControl(null),
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]), referenceNumber: new FormControl(null),
            }),
            notesForm: new FormGroup({
                id: new FormControl(0),
                note: new FormControl(null)
            })
        });
    }
    buildApplication(existingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        return {
            id: existingApplication ? existingApplication.id : 0,
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            applicant: [applicant],
            notes: [],
            eLodgementComplete: false,
            eLodgementStep: 0
        };
    }
    buildBurialDetailsStep(stepIndex, existingApplication) {
        const burialFormValue = this.form.get("burialForm").value;
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.type = burialFormValue.type;
            application.cemeteryId = burialFormValue.cemeteryId.cemeteryId;
            application.cemeteryName = burialFormValue.cemeteryId.cemeteryName;
            application.burialDate = burialFormValue.burialDate;
            application.description = burialFormValue.description;
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                type: burialFormValue.type,
                cemeteryId: burialFormValue.cemeteryId.cemeteryId,
                cemeteryName: burialFormValue.cemeteryId.cemeteryName,
                burialDate: burialFormValue.burialDate,
                description: burialFormValue.description
            };
        return application;
    }
    buildDeceasedStep(stepIndex, existingApplication) {
        const deceasedFormValue = this.form.get("deceasedForm").value;
        if (!existingApplication) {
            existingApplication = {
                id: 0, deleted: false, moduleId: Number(this.appController.selectedModuleID), eLodgementComplete: false,
            };
        }
        existingApplication.eLodgementStep = stepIndex;
        existingApplication.deceased = [deceasedFormValue];
        if (existingApplication.deceased === null && !existingApplication.deceased[0].dateOfDeath)
            existingApplication.deceased[0].dateOfDeath = null;
        // tslint:disable-next-line:prefer-for-of
        if (existingApplication.deceased && existingApplication.deceased.length > 0) {
            if (existingApplication.deceased[0].deceasedNames !== null) {
                for (let index = 0; index < existingApplication.deceased[0].deceasedNames.length; index++) {
                    if (existingApplication.deceased[0].deceasedNames[index].id < 0)
                        existingApplication.deceased[0].deceasedNames[index].id = 0;
                }
            }
        }
        return existingApplication;
    }
    buildFamilyMemberStep(stepIndex, existingApplication) {
        if (!existingApplication) {
            existingApplication = {
                id: 0, deleted: false, moduleId: Number(this.appController.selectedModuleID), eLodgementComplete: false,
            };
        }
        const familyMemberForm = this.form.get("familyMemberForm").value;
        if (familyMemberForm.hasOwnProperty("family")) {
            const familyMemberFormValue = familyMemberForm.family;
            for (let index = 0; index < familyMemberFormValue.length; index++) {
                if (familyMemberFormValue[index].id < 1) {
                    familyMemberFormValue[index].id = 0;
                }
                familyMemberFormValue[index] = RecipientUtils.removeInvalidRecipientProperties(familyMemberFormValue[index]);
            }
            const deletedMembers = [];
            // tslint:disable-next-line:prefer-for-of
            for (let index = 0; index < existingApplication.family.length; index++) {
                const family = familyMemberFormValue.find(f => f.id === existingApplication.family[index].id);
                if (!family) {
                    existingApplication.family[index].deleted = true;
                    deletedMembers.push(existingApplication.family[index]);
                }
            }
            existingApplication.eLodgementStep = stepIndex;
            existingApplication.family = familyMemberFormValue;
            existingApplication.family.push(...deletedMembers);
        }
        return existingApplication;
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        if (!applicant.id)
            applicant.id = 0;
        if (!existingApplication) {
            existingApplication = {
                id: 0, deleted: false, moduleId: Number(this.appController.selectedModuleID), eLodgementComplete: false,
            };
        }
        existingApplication.eLodgementStep = stepIndex;
        existingApplication.applicant = [applicant];
        return existingApplication;
    }
    buildFuneralParlourStep(stepIndex, existingApplication) {
        const funeralParlourIsNullValue = this.form.get("funeralParlourForm").get("funeralParlourIsNull").value;
        const funeralParlourIDValue = this.form.get("funeralParlourForm").get("parlourSelector").value;
        if (existingApplication) {
            existingApplication.eLodgementStep = stepIndex;
            existingApplication.funeralParlourId = funeralParlourIsNullValue ? null : funeralParlourIDValue;
        }
        return existingApplication;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
        }
        else
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true
            };
        return application;
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return;
    }
    verifyExtensionReferenceNumberObservable(params) {
        return;
    }
    getCemeteriesWithAvailableGraves(url) {
        this.requestStatusService.showBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        // @ts-ignore
        this.searchForCemeteries(url).then((cemeteries) => {
            if (cemeteries && cemeteries.length > 0) {
                const sortedCemeteries = cemeteries.sort((a, b) => a?.cemeteryName?.localeCompare(b?.cemeteryName));
                this.cemeteryList.next(sortedCemeteries);
                return sortedCemeteries;
            }
        }).catch((error) => {
            this.appController.showConsoleMessage(error);
            return [];
        })
            .finally(() => {
            this.requestStatusService.removeBusySpinner(SharedConstants.PROPERTY_SEARCH_STATUS);
        });
        return [];
    }
    async searchForCemeteries(url) {
        const featureSet = await this.searchAllItems(url, false, CemeterySearchOption.Cemetery, false, true);
        return featureSet;
    }
    async searchAllItems(url, returnGeometry, searchOption, returnTopOne, returnAllColumns) {
        const cemeteryOption = ["*"];
        return query.executeQueryJSON(url, this.buildQuery("1=1", cemeteryOption, returnGeometry, returnTopOne, returnAllColumns));
    }
    getLayerUrl(searchType) {
        switch (searchType) {
            case CemeterySearchOption.Cemetery:
                return this.cemeteryUrl;
            case GraveSearchOption.Grave:
                return this.graveUrl;
            default:
                return this.cemeteryUrl;
        }
    }
    setURL(searchType, url) {
        switch (searchType) {
            case GraveSearchOption.Grave:
                this.graveUrl = url;
                break;
            case CemeterySearchOption.Cemetery:
                this.cemeteryUrl = url;
                break;
        }
    }
    buildQuery(whereClause, outFields, returnGeometry, returnTopOne, returnAllColumns) {
        const newQuery = new Query();
        newQuery.where = whereClause;
        newQuery.returnGeometry = returnGeometry;
        // @ts-ignore
        // newQuery.outFields = returnAllColumns ? "*" : outFields;
        newQuery.outFields = "*";
        if (returnTopOne) {
            newQuery.maxRecordCountFactor = 1;
        }
        newQuery.outSpatialReference = new SpatialReference({
            wkid: 102100
        });
        return newQuery;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
CemeteryStrategyService = CemeteryStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsubPortal()
], CemeteryStrategyService);
export { CemeteryStrategyService };
